import { connectFirestoreEmulator } from 'firebase/firestore/lite';
import { connectStorageEmulator } from 'firebase/storage';

import FirebaseCloudStorage from '.';
import FirebaseEmulatorAuth from '../../Authentication/emulator';
import { logger } from 'services/Logger';

class FirebaseEmulatorStorage extends FirebaseCloudStorage {
  isConnected = false;

  constructor(...args: ConstructorParameters<typeof FirebaseCloudStorage>) {
    super(...args);
    const auth = args[1];
    // Connect to emulators immediately
    const host = process.env.REACT_APP_HOST ?? 'localhost';
    this.connectToEmulators(host);

    if (auth instanceof FirebaseEmulatorAuth) {
      auth.onSetUser = (result) => {
        logger.debug('🔐 EMULATOR Auth User Set:', result);
      };
    }
  }

  private connectToEmulators(host: string) {
    try {
      connectFirestoreEmulator(this.db, host, 8080);
      connectStorageEmulator(this.storage, host, 9199);

      this.isConnected = true;
    } catch (error) {
      this.isConnected = true; // Assume already connected
    }
  }
}

export default FirebaseEmulatorStorage;
